module.exports = __webpack_public_path__ + "img/手机长图3.277916f5.png";